import { render, staticRenderFns } from "./allDeviceParametersDataReport.vue?vue&type=template&id=5825a51c&scoped=true"
import script from "./allDeviceParametersDataReport.vue?vue&type=script&lang=js"
export * from "./allDeviceParametersDataReport.vue?vue&type=script&lang=js"
import style0 from "./allDeviceParametersDataReport.vue?vue&type=style&index=0&id=5825a51c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825a51c",
  null
  
)

export default component.exports